import './sentryClientBootstrap';
import {createRoot} from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import {initAppearanceFromStorage} from './contexts/AppearanceContext';
import {initAnalytics} from './lib/analytics';

initAppearanceFromStorage();

createRoot(document.getElementById('root')!).render(<App />);

initAnalytics();
